import * as ExcelJS from 'exceljs';

import Worker from 'src/projects/utils/xlsxWorker?worker&inline';

export type WorkSheet = {
    columns: Partial<ExcelJS.Column>[];
    rows: ExcelJS.CellValue[][];
    name: string;
};

export type WorkBook = {
    actuators: WorkSheet;
    sensors: WorkSheet;
    valves: WorkSheet;
};

const worker = new Worker();
export const composeExcelBuffer = async (workbook: WorkBook): Promise<ExcelJS.Buffer> => {
    const channel = new MessageChannel();
    const promise = new Promise<ExcelJS.Buffer>((resolve, reject) => {
        channel.port2.onmessage = (event: MessageEvent<{ response: ExcelJS.Buffer } | { error: Error }>) => {
            channel.port2.close();
            if ('error' in event.data) {
                reject(event.data.error);
            } else {
                resolve(event.data.response);
            }
        };
    });
    worker.postMessage(workbook, [channel.port1]);
    return promise;
};
